import React from 'react';
import '../css/Map.css';

export default class MapPage extends React.Component {
    render() {
        return (
            <div className="app-page" id="map-page">
                <h1> CUPPY Partner Locations</h1>
                <p>CUPPY will be in use at all the following locations.</p>
                <iframe title="locations-map" id="partner-locations-map" src="https://www.google.com/maps/d/u/0/embed?mid=1Hqv1bV8ZXx7FAoetYtBNF4Vx-iEvXC01"></iframe><br/>
                <button onClick={() => { this.props.returnToAccount(); }} id="back2acc-btn">&lt; Back to Account</button>
            </div>
        )
    }
}